import { render } from "./MasterBlock.vue?vue&type=template&id=502871e8"
import script from "./MasterBlock.vue?vue&type=script&lang=js"
export * from "./MasterBlock.vue?vue&type=script&lang=js"

import exportComponent from "/home/jbenes/PhpstormProjects/VUE/VUE_Neustadt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__